/* src/app/component/sidebar/achievements/achievements.component.scss */
:host {
  padding: 0;
  width: 100%;
}
@media screen and (min-width: 48rem) {
  :host {
    padding: 0.75rem 0;
  }
}
.achievements {
  display: flex;
  flex-direction: row;
  border-radius: 0.5rem;
  padding: 1rem 1rem;
}
@media screen and (min-width: 48rem) {
  .achievements {
    padding: 1.25rem 2.25rem;
  }
}
.achievements__badges {
  width: 100%;
}
.achievements__badges h4 {
  font-size: 1.25rem;
  margin-bottom: 1.5rem;
}
.achievements__badges--icons {
  display: flex;
  gap: 1.25rem;
  height: 2rem;
  justify-content: space-between;
}
.achievements__badges--icons img {
  width: 2rem;
}
.achievements.dialog-style {
  background: none;
  box-shadow: none;
  text-align: center;
}
.achievements.dialog-style .achievements__badges {
  margin: 0 auto;
}
.achievements.dialog-style .achievements__badges h4 {
  display: none;
}
.achievements.dialog-style .achievements__badges--icons {
  display: flex;
  justify-content: center;
  gap: 0.25rem;
}
@media screen and (min-width: 48rem) {
  .achievements.dialog-style .achievements__badges--icons {
    gap: 0.5rem;
  }
}
.achievements.dialog-style .achievements__badges--icons img {
  height: 2rem;
  width: 2rem;
}
@media screen and (min-width: 48rem) {
  .achievements.dialog-style .achievements__badges--icons img {
    height: 2rem;
    width: 3rem;
  }
}
/*# sourceMappingURL=achievements.component.css.map */
